const removeProductFromFavorites = (data) => {
	const deletedId = data.initialId;
	const favorites = Array.from(document.querySelectorAll('.favorite-product-js'));
	const favoriteCount = document.querySelector('.favorite-count-js');
	const favoriteList = document.querySelector('.favorite-list-js');
	const newFavoriteCount = favorites.length - 1;
	favorites.forEach((favorite) => {
		if (favorite.dataset.favoriteId === deletedId) {
			favorite.remove();
		}
	});
	favoriteCount.innerHTML = newFavoriteCount;
	if (newFavoriteCount <= 0) {
		favoriteList.remove();
	}
};

document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.delete-favorite-js') !== null) {
		const deleteFavoriteButtons = Array.from(document.querySelectorAll('.delete-favorite-js'));
		deleteFavoriteButtons.forEach((button) => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				const element = e.target;
				const favoriteId = element.dataset.favoriteId;
				reservationsApi.deleteFavoriteProduct(favoriteId, removeProductFromFavorites);
			});
		});
	}
});

const formatDateOfBirth = () => {
	const year = document.querySelector('.dob-year-js').value;
	let month = document.querySelector('.dob-month-js').value;
	let day = document.querySelector('.dob-day-js').value;
	day = (day.length === 1) ? `0${day}` : day;
	month = (month.length === 1) ? `0${month}` : month;

	const field = document.querySelector('#id_birthdate');
	const dateOfBirth = moment(`${year}-${month}-${day}`, 'YYYY-MM-DD', true);

	if (dateOfBirth.isValid()) {
		field.value = dateOfBirth.format('YYYY-MM-DD');
	} else {
		field.value = '';
	}
};

if (document.querySelector('.dob-day-js')) {
	document.querySelector('.dob-day-js').addEventListener('keyup', (e) => {
		e.preventDefault();
		formatDateOfBirth();
	});
}

if (document.querySelector('.dob-month-js')) {
	document.querySelector('.dob-month-js').addEventListener('keyup', (e) => {
		e.preventDefault();
		formatDateOfBirth();
	});
}

if (document.querySelector('.dob-year-js')) {
	document.querySelector('.dob-year-js').addEventListener('keyup', (e) => {
		e.preventDefault();
		formatDateOfBirth();
	});
}

function ready(fn) {
  if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"){
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

ready(() => {
	let voorletters = document.querySelector('.contact-form #voorletters');
	let tussenvoegsel = document.querySelector('.contact-form #tussenvoegsel');
	let achternaam = document.querySelector('.contact-form #achternaam');
  let name = document.querySelector('.contact-form [name=name]');

  if (voorletters !== null && voorletters !== undefined && tussenvoegsel !== null &&
		tussenvoegsel !== undefined && achternaam !== null && achternaam !== undefined) {
    let mergeName = function(e) {
      let whitespace = (tussenvoegsel.value.length > 0) ? ' ' : '';
      name.value = `${voorletters.value} ${tussenvoegsel.value}${whitespace}${achternaam.value}`;
    };
    voorletters.addEventListener('change', mergeName);
    tussenvoegsel.addEventListener('change', mergeName);
    achternaam.addEventListener('change', mergeName);
	}
});